import Component from "../../../../Component";
import { MinimalGalleryState } from "../..";

export class AppView extends Component<MinimalGalleryState> {
    constructor(props: __Component.Props) {
        super(props);
        // force https url
        // this.props.items.viewerItem.url = this.props.items.viewerItem.url.replace(/^http:\/\//i, 'https://');
    }

    render() {
        const tsx = this.tsx;

        return (
            <iframe
                src={this.props.items.viewerItem.url}
                class="app-frame"
                id="embedded-mapping-application-iframe"
                name="nested-iframe"
            >
                <h3 class="center-style">{this.props.base.i18n.viewLoading.iframe}</h3>
            </iframe>
        );
    }
}


// WEBPACK FOOTER //
// ./src/mainApp/MinimalGallery/Viewer/View/AppView.tsx